<!--智慧暖通-->
<template>
  <div class="product3">
    <!--主体内容-->
    <div class="x-container">
      <p class="p_title">GREE GMOS+手机APP隐私政策</p>
      <!--格力轻商空调智慧管理系统-->
      <p class="p_text">本政策仅适用于珠海格力电器股份有限公司（以下简称“格力”或“我们”）的GREE GMOS+提供的产品或服务，包括访问GREE GMOS+使用平台提供的服务。</p>
      <p class="p_text">最近更新日期：2025年09月18日，版本号为v1.1。</p>
      <p class="p_text">版本生效日期：2025年09月18日。</p>
      <p class="p_text">一、我们如何收集和使用您的个人信息</p>
      <p class="p_text">二、我们如何共享、转让、公开披露您的个人信息</p>
      <p class="p_text">三、我们如何保护您的个人信息</p>
      <p class="p_text">四、我们如何处理儿童的个人信息</p>
      <p class="p_text">五、我们如何使用Cookie和同类技术</p>
      <p class="p_text">六、您的权利</p>
      <p class="p_text">七、您的个人信息如何储存及超出储存期限处理办法</p>
      <p class="p_text">八、本政策如何更新</p>
      <p class="p_text">九、如何联系我们</p>
      <p class="p_text">
        我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。同时，格力承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
      </p>
      <p class="p_text" style="font-weight: bold">请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。 并确保您已充分了解且同意我们处理您个人信息的目的、方式和范围。</p>
      <p class="p_title2">一、我们如何收集和使用您的个人信息</p>
      <p class="p_text">个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合
        识别特定自然人身份或者反映特定自然人活动情况的各种信息。<strong>格力仅会出于本政策所述的以下目的，收集和使用您的个人信息。处理个人信息的目的包括：</strong></p>
      <p class="p_text">1、创建您的GREE GMOS+账号</p>
      <p class="p_text">2、能够控制和使用设备</p>
      <p class="p_text">3、评估与分析App产品功能与服务情况</p>
      <p class="p_text">4、进行通知或推送</p>
      <p class="p_text">5、提供App安全保障</p>
      <p class="p_text">6、其他GREE GMOS+服务</p>
      <p class="p_text">
        <strong>如果处理个人信息的目的、方式和种类发生变更的，格力将重新取得您的同意。以下罗列某些特殊的个人信息属于个人敏感信息，如实时画面、不满十四周岁未成年人的个人信息，在提供前，您需要谨慎考虑，确保准确。</strong>
        格力会对敏感信息单独征得您的同意，并按国家要求加强安全保密处理。
      </p>
      <p class="p_text">（一）您向我们提供的信息</p>
      <p class="p_text">我们会获取您使用GMVisual Master、GREE GMOS+时提供的相关服务时填写及/或提交的信息，包括您的姓名、电话号码、电子邮箱和相关附加信息。</p>
      <p class="p_text">GREE GMOS+将通过GREE
        GMOS+页面向您展示需要您提交的信息，届时以页面展示为准，如果您不使用某些服务，则无需提供相关信息。对于您明确拒绝使用、关闭或退出的特定业务功能，App在您打开该业务功能或相关系统权限时将会再次询问您是否您是否同意开启相关权限，且App在更新升级后，
        不会更改原有的系统权限设置。</p>
      <p class="p_text">（二）在您使用服务过程中收集的信息</p>
      <p class="p_text" style="font-weight: bold">
        为实现向您提供我们产品及服务的附加功能，您可以选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，不会影响您使用我们的基本功能。</p>
      <p class="p_text">我们收集您使用产品和服务的相关信息包括：</p>
      <p class="p_text">2.1我们会在根据您在软件安装及使用汇总授予的具体权限，接收并记录您所使用的智能设备相关信息，用于为您提供智能设备连接和设备管理的功能。这些信息包括：</p>
      <p class="p_text"><strong>登录账号信息：</strong>帐号、昵称、头像信息；</p>
      <p class="p_text"><strong>手机相关信息：</strong>硬件设备标识(imsi、 imei、meid、设备硬 件序列号、SIM 卡标识、OAID、Mac 地址、Android
        ID)、手机型号、系统版本信息、系统语言、手机所设置的国家或地区、应用商店的版本号、手机屏幕尺寸及分辨率、CPU及显示设备相关信息
        设备信息：连接智能设备过程中收集的信息，基于您需要链接的智能设备的类型，我们会收集Wi-Fi信息（SSID、BSSID、Wi-Fi的Mac地址、Wi-Fi密码）、设备
        Mac地址、设备ID、设备蓝牙Mac地址）、设备唯一标识字符，您对软硬件的使用记录、软硬件故障信息数据，包括您的IP地址、访问日期和时间、语言、软硬件特征信息；如您下载或使用格力或其关联公司客户端软件，格力会读取与您位置和移动设备相关的信息，包括设备型号、操作系统、设备识别码、分辨率、电信运营商。
      </p>
      <p class="p_text">为实现向您提供我们产品及/或服务的必要的功能，您须授权我们手机、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用对应的某些功能或服务。</p>
      <p class="p_text">
        2.2除上述信息外，我们还可能为了提供服务及改进服务质量、服务个性化的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您与格力的关联方、合作伙伴之间互动时我们收集的相关信息。与此同时，
        <strong>为提高您使用格力平台服务时的安全性，预防钓鱼网站欺诈和木马病毒，我们可能会通过了解或记录一些您的网络使用习惯、您常用的软件信息来判断您账户的风险，并可能会记录一些我们认为有风险的URL。</strong>
        为实现向您提供我们产品及服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的效果，不会影响您使用我们的基本功能。
      </p>
      <p class="p_text">以下为相关应用场景/业务功能及影响：</p>
      <p class="p_text">能源：碳排、用水、用电、用气统计；</p>
      <p class="p_text">智控：设备监控；</p>
      <p class="p_text">运维服务：根据用户填写的信息提供相关工单管理、保养管理、巡检管理、备件管理、安全检查、设备管理、故障管理、报警管理、运维数据统计、学习培训。</p>
      <p class="p_text">涉及的各项业务功能实际收集的个人信息类型与隐私政策所描述内容一致，且不会超出隐私政策所述范围。</p>
      <p class="p_text">2.3GREE GMOS+可能会调用您的设备权限，以下是调用权限对应的业务功
        能、我们调用的目的以及调用前向您询问的情况。您可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝我们调用相关权限。</p>
      <div style="padding: 10px 10px">
        <table class="p_table">
          <thead>
            <tr class="p_tableborder">
              <th class="p_tableborder" style="width: 15%">设备权限</th>
              <th class="p_tableborder" style="width: 30%">对应业务</th>
              <th class="p_tableborder" style="width: 35%">调用权限目的</th>
              <th class="p_tableborder" style="width: 10%">是否询问</th>
              <th class="p_tableborder" style="width: 10%">用户可否关闭权限</th>
            </tr>
          </thead>
          <tbody>
            <tr class="p_tableborder">
              <td class="p_tableborder">存储</td>
              <td class="p_tableborder">插件更新；图片信息存储；App升级</td>
              <td class="p_tableborder">访问设备上的照片、媒体内容和文件</td>
              <td class="p_tableborder">是</td>
              <td class="p_tableborder">是</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">相机</td>
              <td class="p_tableborder">个人头像、拍照</td>
              <td class="p_tableborder">使用相机进行扫描二维码进行报修、添加设备；运维过程的拍照记录</td>
              <td class="p_tableborder">是</td>
              <td class="p_tableborder">是</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">电话</td>
              <td class="p_tableborder">拨打电话</td>
              <td class="p_tableborder">拨打维修电话</td>
              <td class="p_tableborder">是</td>
              <td class="p_tableborder">是</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">推送</td>
              <td class="p_tableborder">工单、巡检、保养等</td>
              <td class="p_tableborder">接收待办任务信息</td>
              <td class="p_tableborder">是</td>
              <td class="p_tableborder">是</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">位置信息</td>
              <td class="p_tableborder">工单报修</td>
              <td class="p_tableborder">获取用户位置信息进行报修</td>
              <td class="p_tableborder">是</td>
              <td class="p_tableborder">是</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">相册</td>
              <td class="p_tableborder">工单、巡检、保养等</td>
              <td class="p_tableborder">访问手机存储的图片文件，用于图片选取上传</td>
              <td class="p_tableborder">是</td>
              <td class="p_tableborder">是</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="p_text">2.4为识别您的设备ID并预防恶意程序及反作弊、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息（包括设备序列号、IMEI、 MEID、Android
        ID、IMSI、GUID、MAC地址）、您安装的应用信息或运行中的进程信息。</p>
      <p class="p_text">2.5在您使用App录像照相相关功能时，会获取加速度设备传感器信息，用于获取拍摄手机角度。</p>
      <p class="p_text">2.6快捷控制功能</p>
      <p class="p_text">为向您提供快捷便利的智能设备控制体验，我们会收集以下信息：</p>
      <p class="p_text">设备状态：以供您查看设备状态，根据状态展示不同操作界面；</p>
      <p class="p_text">
        设备状态信息：以使您查看设备状态并实现设备控制；如果您连接了可检测温度、湿度设备等，我们还需收集：设备周围环境相关信息：以使您准确的查看设备传感器检测到的周围环境相关信息，例如温度、湿度、PM2.5 等。</p>
      <p class="p_text">
        （三）我们还可能收集其他无法识别到特定个人的信息（即不属于个人信息的信息），例如您使用特定服务时产生的统计类数据，如用户的操作行为（包括点击、页面跳转、浏览时间）、账号下设备信息（包括设备类别、数目、参数状态等）。收集此类信息的目的在于改善我们向您提供的服务。所收集信息的类别和数量取决于您如何使用我们产品和/或服务。我们会将此类信息汇总，用于帮助我们向客户提供更有用的信息，了解客户对我们网站、产品和服务中的哪些部分最感兴趣。就本隐私政策而言，汇总数据被视为非个人信息。如果我们将非个人信息与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
      </p>
      <p class="p_text">（四）您充分知晓，以下情形中，我们收集、使用、共享、转让、公开披露您的个人信息或非个人信息无需征得您的同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
      <p class="p_text">4.1与国家安全、国防安全有关的；</p>
      <p class="p_text"> 4.2与公共安全、公共卫生、重大公共利益有关的；</p>
      <p class="p_text">4.3与犯罪侦查、起诉、审判和判决执行有关的；</p>
      <p class="p_text">4.3与犯罪侦查、起诉、审判和判决执行有关的；</p>
      <p class="p_text">4.4出于维护个人信息主体或其他个人的生命、财产此类重大合法权益但又很难得到本人同意的；</p>
      <p class="p_text">4.5所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
      <p class="p_text">4.6 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开渠道；</p>
      <p class="p_text">4.7根据您的要求签订合同所必需的；</p>
      <p class="p_text">4.8为合法的新闻报道所必需的（为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息）；</p>
      <p class="p_text">4.9法律法规规定的其他情形。</p>
      <p class="p_title2">二、我们如何共享、转让、公开披露您的个人信息</p>
      <p class="p_text">（一）共享</p>
      <p class="p_text">我们不会与格力以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
      <p class="p_text">1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
      <p class="p_text">2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 </p>
      <p class="p_text">3、第三方服务提供者可以通过app向您或企业用户提供产品或者服务，具体第三方公司见下方关联的第三方SDK清单。</p>
      <p class="p_text">
        4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
        对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
      <p class="p_text">5、针对第三方SDK使用，我们将基于不同步用户个人数据为前提，授权合作伙伴获取有关业务信息。同时针对第三方的
        SDK应用程序接口（API），软件工具开发包（SDK）我们会进行严格的安全监测，并与合作伙伴签订严格的数据保护协定，令其按照我们的委托目的、服务说明、本隐私政策以及其它任何相关的保密和安全措施来处理个人信息。</p>
      <p class="p_text">目前我们系统产品中存在的第三方SDK披露如下：</p>
      <div style="padding: 10px 10px">
        <table class="p_table">
          <thead>
            <tr class="p_tableborder">
              <th class="p_tableborder" style="width: 5%">第三方SDK</th>
              <th class="p_tableborder" style="width: 50%">接入目的/第三方名称</th>
              <th class="p_tableborder" style="width: 45%">获取个人信息</th>
            </tr>
          </thead>
          <tbody>
            <tr class="p_tableborder">
              <td class="p_tableborder">极光推送SDK</td>
              <link class="p_tableborder">
              极光推送服务为APP赋予消息和通知的推送能力。在集成极光推送SDK后，极光推送SDK会收集使用实现服务所必须的个人信息，通过加密的通道将消息和通知推送给App的终端用户。<br>
              极光隐私政策链接：
              <a href="https://www.jiguang.cn/license/privacy"
                style="color: #3f9beb;">https://www.jiguang.cn/license/privacy</a><br>
              第三方名称：深圳市和讯华谷信息技术有限公司
              <td class="p_tableborder">
                设备信息:设备标识符(IEMI、IDFA、AndroidID、MAC、OAID相关信息)、应用信息(应用崩溃信息、通知开关状态、软件列表相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)；<br>
                网络信息：IP地址、WiFi信息、基站信息；<br>
                位置信息：设备位置</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">极光推送SDK-华为厂商通道</td>
              <td class="p_tableborder">极光推送为了提升送达率、解决厂商通道的配额限制和保障消息即时送达等问题，为开发者提供了多种推送策略，开发者在推送管理后台可以选择合适的发送策略，在 API
                端支持开发者以厂商通道为颗粒度制定发送策略。<br>
                极光隐私政策链接：
                <a href="https://www.jiguang.cn/license/privacy"
                  style="color: #3f9beb;">https://www.jiguang.cn/license/privacy</a><br>
                第三方名称：深圳市和讯华谷信息技术有限公司
              </td>
              <td class="p_tableborder">
                设备信息:设备标识符(IEMI、IDFA、AndroidID、MAC、OAID相关信息)、应用信息(应用崩溃信息、通知开关状态、软件列表相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)；<br>
                网络信息：IP地址、WiFi信息、基站信息；<br>
                位置信息：设备位置</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">极光推送SDK-Vivo厂商通道</td>
              <td class="p_tableborder">极光推送为了提升送达率、解决厂商通道的配额限制和保障消息即时送达等问题，为开发者提供了多种推送策略，开发者在推送管理后台可以选择合适的发送策略，在 API
                端支持开发者以厂商通道为颗粒度制定发送策略。<br>
                极光隐私政策链接：
                <a href="https://www.jiguang.cn/license/privacy"
                  style="color: #3f9beb;">https://www.jiguang.cn/license/privacy</a><br>
                第三方名称：深圳市和讯华谷信息技术有限公司
              </td>
              <td class="p_tableborder">
                设备信息:设备标识符(IEMI、IDFA、AndroidID、MAC、OAID相关信息)、应用信息(应用崩溃信息、通知开关状态、软件列表相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)；<br>
                网络信息：IP地址、WiFi信息、基站信息；<br>
                位置信息：设备位置</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">极光推送SDK-魅族厂商通道</td>
              <td class="p_tableborder">极光推送为了提升送达率、解决厂商通道的配额限制和保障消息即时送达等问题，为开发者提供了多种推送策略，开发者在推送管理后台可以选择合适的发送策略，在 API
                端支持开发者以厂商通道为颗粒度制定发送策略。<br>
                极光隐私政策链接：
                <a href="https://www.jiguang.cn/license/privacy"
                  style="color: #3f9beb;">https://www.jiguang.cn/license/privacy</a><br>
                第三方名称：深圳市和讯华谷信息技术有限公司
              </td>
              <td class="p_tableborder">
                设备信息:设备标识符(IEMI、IDFA、AndroidID、MAC、OAID相关信息)、应用信息(应用崩溃信息、通知开关状态、软件列表相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)；<br>
                网络信息：IP地址、WiFi信息、基站信息；<br>
                位置信息：设备位置</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">极光推送SDK-小米厂商通道</td>
              <td class="p_tableborder">极光推送为了提升送达率、解决厂商通道的配额限制和保障消息即时送达等问题，为开发者提供了多种推送策略，开发者在推送管理后台可以选择合适的发送策略，在 API
                端支持开发者以厂商通道为颗粒度制定发送策略。<br>
                极光隐私政策链接：
                <a href="https://www.jiguang.cn/license/privacy"
                  style="color: #3f9beb;">https://www.jiguang.cn/license/privacy</a><br>
                第三方名称：深圳市和讯华谷信息技术有限公司
              </td>
              <td class="p_tableborder">
                设备信息:设备标识符(IEMI、IDFA、AndroidID、MAC、OAID相关信息)、应用信息(应用崩溃信息、通知开关状态、软件列表相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)；<br>
                网络信息：IP地址、WiFi信息、基站信息；<br>
                位置信息：设备位置</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">极光推送SDK-OPPO厂商通道</td>
              <td class="p_tableborder">极光推送为了提升送达率、解决厂商通道的配额限制和保障消息即时送达等问题，为开发者提供了多种推送策略，开发者在推送管理后台可以选择合适的发送策略，在 API
                端支持开发者以厂商通道为颗粒度制定发送策略。<br>
                极光隐私政策链接：
                <a href="https://www.jiguang.cn/license/privacy"
                  style="color: #3f9beb;">https://www.jiguang.cn/license/privacy</a><br>
                第三方名称：深圳市和讯华谷信息技术有限公司
              </td>
              <td class="p_tableborder">
                设备信息:设备标识符(IEMI、IDFA、AndroidID、MAC、OAID相关信息)、应用信息(应用崩溃信息、通知开关状态、软件列表相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)；<br>
                网络信息：IP地址、WiFi信息、基站信息；<br>
                位置信息：设备位置</td>
            </tr>
            <tr class="p_tableborder">
              <td class="p_tableborder">腾讯BuglySDK</td>
              <td class="p_tableborder">可以让您及时发现应用的异常，并通过丰富的现场信息帮您快速定位和解决问题。<br>
                腾讯隐私政策链接：
                <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                  style="color: #3f9beb;">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a><br>
                第三方名称：深圳市腾讯计算机系统有限公司
              </td>
              <td class="p_tableborder">日志信息；设备ID（包括AndroidID以及idfv）；联网信息；系统名称；系统版本以及国家码</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="p_text">（二）转让</p>
      <p class="p_text">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p class="p_text">1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</p>
      <p class="p_text">2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
      <p class="p_text">（三）公开披露</p>
      <p class="p_text">我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p class="p_text">1、获得您明确同意后。</p>
      <p class="p_text">2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
      <p class="p_title2">三、我们如何保护您的个人信息</p>
      <p class="p_text">我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息。相关技术与措施包括：</p>
      <p class="p_text">1、数据安全技术措施</p>
      <p class="p_text">我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数
        据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意代码攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；
      </p>
      <p class="p_text">2、其他安全措施</p>
      <p class="p_text">2.1我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
      <p class="p_text">2.2GREE GMOS+通过建立数据分类分级制度、数据安全管理规范、数据安 全开发规范来管理规范个人信息的存储和使用。</p>
      <p class="p_text">2.3GREE GMOS+通过信息接触者保密协议、监控和审计机制来对数据进行 全面安全控制。</p>
      <p class="p_text">2.4GREE GMOS+建立数据安全委员会并下设信息保护专职部门、数据安全 应急响应组织来推进和保障个人信息安全。</p>
      <p class="p_text">2.5加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
      <p class="p_text">2.6我们仅允许有必要知晓这些信息的GREE GMOS+及GREE
        GMOS+关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与GREE
        GMOS+的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与格力的合作关系。</p>
      <p class="p_text">3、互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他 GREE
        GMOS+用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
      <p class="p_text">4、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。</p>
      <p class="p_text">
        5、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以邮件、信函、电话、推送通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </p>
      <p class="p_text">6、为应对个人信息泄露、损毁和丢失此类可能出现的风险，GREE
        GMOS+产品制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
      </p>
      <p class="p_text" style="font-weight: bold">
        7、如果您对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策最下方【如何联系我们】约定的联系方式联络我们，以便我们采取相应措施。
      </p>
      <p class="p_title2">四、我们如何处理儿童的个人信息</p>
      <p class="p_text">
        我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
      </p>
      <p class="p_title2">五、我们如何使用 Cookie 和同类技术 </p>
      <p class="p_text">（一）Cookie </p>
      <p class="p_text">
        为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，设备能够存储您的偏好或使用的智能产品数据。我们不会将Cookie用于本政策所述目的(分享/第三方登录)之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除设备上保存的所有Cookie，但如果您这么做，则需要在每一次访问我们的时候更改用户设置。我们不存在嵌入第三方代码插件收集个人信息的功能。
        大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</p>
      <p class="p_title2">六、您的权利 </p>
      <p class="p_text">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利： </p>
      <p class="p_text">(一）访问您的个人信息</p>
      <p class="p_text">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：账户信息——如果您希望访问您的账户中的个人资料信息、更改您的密码， 您可以通过访问GREE
        GMOS+执行此类操作。如果您无法通过上述链接访问这些个人信息，您可以通过发送电子邮件security@cn.gree.com 的方式提出访问请求，我们将在15天内回复您的访问请求。</p>
      <p class="p_text">对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。</p>
      <p class="p_text">（二）更正您的个人信息</p>
      <p class="p_text">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。如果您无法通过上述链接更正这些个人信息，您可以随时使用GREE
        GMOS+反馈问题给我们，或发送电子邮件至格力。我们将在15天内回复您的更正请求。</p>
      <p class="p_text">（三）改变您授权同意的范围 </p>
      <p class="p_text">
        每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于额外收集的个人信息的收集和使用，<strong>您可以通过以下方式改变或收回您同意我们收集您个人信息的范围：</strong></p>
      <p class="p_text">1.通过解绑删除设备收回部分授权；</p>
      <p class="p_text">2.通过移动设备设置功能，关闭相应权限，包括：存储、相机，收回对应个人信息授权；</p>
      <p class="p_text">3.通过注销您的账号收回全部个人信息授权；</p>
      <p class="p_text">4.除上述方式外，您还可以通过联系我们的个人信息保护专职部门（见本政策“第九部分”）处理您的个人信息。</p>
      <p class="p_text">当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
      <p class="p_text">（四）注销您的账号</p>
      <p class="p_text">您可以随时注销您的账号，如有需要，在登录GREE GMOS+后可进行注销账号操作，在满足注销账号条件下可直接注销账号。</p>
      <p class="p_text">账号注销途径：</p>
      <p class="p_text">1、进入GREE GMOS+，“我的”中点击“账户与安全”—“账号注销”。</p>
      <p class="p_text">2、选择账号注销原因，点击“下一步”；</p>
      <p class="p_text">3、输入手机号，并获取并输入验证码后，点击“账号注销”，即注销账号成功。</p>
      <p class="p_text">关于账号注销，您需要注意的事项如下：</p>
      <p class="p_text">1、您应确保您拥有该账号的所有权，有权决定该账号的注销事宜，不侵犯任何第三方的合法权益。如因此引发任何争议，由您自行承担责任。</p>
      <p class="p_text">2、您理解并同意在注销账号之后，您将无法再使用该账号，无法远程控制您的设备，同时账号个人资料与设备信息将会被清除，且无法恢复。请您在申请注销前自行备份您欲保留的本帐号信息和数据。</p>
      <p class="p_text">3、您注销账号的行为并不代表本帐号在注销前的帐号行为和相关责任得以豁免或减轻。如您在使用帐号时有任何违法违规的不当行为，我们将对您帐号注销前的违法及不当行为保有追责的权利。</p>
      <p class="p_text">（五）个人信息删除权</p>
      <p class="p_text">
        您有权要求我们删除您的个人数据。我们将会根据您的删除请求进行评估，若满足相应规定，我们将会采取包括技术手段在内的相应步骤进行处理。在以下情形中，您可以通过本隐私政策最下方列明的联系方式与我们取得联系，向我们提出删除个人信息的请求：
      </p>
      <p class="p_text">1. 如果我们处理个人信息的行为违反法律法规；</p>
      <p class="p_text">2. 如果我们收集、使用您的个人信息，却未征得您的同意；</p>
      <p class="p_text">3. 如果我们处理个人信息的行为严重违反了与您的约定；</p>
      <p class="p_text">4. 如果您主动注销了帐号；</p>
      <p class="p_text">5. 如果永久不需要我们提供产品或服务；</p>
      <p class="p_text">6. 如果我们违反与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息；</p>
      <p class="p_text">
        7.如果我们决定响应您的删除请求，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息；因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。但若您提出的要求存在无实质意义/纠缠式重复、损害他人隐私权、极度极端不现实的情况，或者删除个人信息从技术上难以实现、不符合法律法规，在我们评估后认为删除数据可能会导致我们无法出于安全目的合法使用数据，可能也会予以拒绝。
      </p>
      <p class="p_text">（六）个人信息携带权</p>
      <p class="p_text">您可以随时获取您的个人信息。如有需要，您可以通过本隐私政策最下方列明的联系方式，与我们取得联系后获取。</p>
      <p class="p_text">（七）个人信息拒绝权</p>
      <p class="p_text">
        在您使用我们的服务时，我们可能会将经处理过的无法识别您身份后的数据做分析，以改善我们的产品与服务。我们不会使用您的数据来执行任何完全自动化的决策。如果您对我们处理个人信息的准确性或合法性有争议，您有权要求我们进行限制处理的权利；可通过关闭权限来限制我们获取您的个人信息，但您的限制处理权可能会导致您无法正常使用我们的服务。
      </p>
      <p class="p_text">（八）响应您的上述请求</p>
      <p class="p_text">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15天内做出答复。如您不满意，还可以联系客服投诉。</p>
      <p class="p_text">
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
      </p>
      <p class="p_text">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
      <p class="p_text">1、与国家安全、国防安全直接相关的。 </p>
      <p class="p_text">2、与公共安全、公共卫生、重大公共利益直接相关的。</p>
      <p class="p_text">3、与犯罪侦查、起诉、审判和判决执行直接相关的。 </p>
      <p class="p_text">4、有充分证据表明您存在主观恶意或滥用权利的。</p>
      <p class="p_text">5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
      <p class="p_text">6、涉及商业秘密的。</p>
      <p class="p_title2">七、您的个人信息如何储存及超出储存期限处理办法</p>
      <p class="p_text">我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。对于您个人信息的存储期限将依照法律最短期限进行处理。</p>
      <p class="p_text">除非法律另有明文规定或经您允许，我们只会在本隐私政策所述目的所需 的期限内保留您的个人信息。为了保持服务的持续性和用户体验的一致性，个人信息通常不会在单项服务完成后立即删除。</p>
      <p class="p_title2">八、本政策如何更新 </p>
      <p class="p_text">
        我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更，并重新取得您的同意。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过短信发送通知，说明隐私政策的具体变更内容）。
      </p>
      <p class="p_text">本政策所指的重大变更包括：</p>
      <p class="p_text">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式。</p>
      <p class="p_text">2、我们在所有权结构、组织架构方面发生重大变化。如业务调整、破产并购引起的所有者变更。</p>
      <p class="p_text">3、个人信息共享、转让或公开披露的主要对象发生变化。</p>
      <p class="p_text">4、您参与个人信息处理方面的权利及其行使方式发生重大变化。</p>
      <p class="p_text">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。</p>
      <p class="p_text">个人信息安全影响评估报告表明存在高风险时。我们还会将本政策的旧版本存档，供您查阅。</p>
      <p class="p_title2">九、如何联系我们</p>
      <p class="p_text" style="font-weight: bold">如果您对本隐私政策有任何疑问、意见或建议，您可以通过如下方式与我们取得联系：</p>
      <p class="p_text" style="font-weight: bold">联系人：珠海格力电器股份有限公司</p>
      <p class="p_text" style="font-weight: bold">电子邮件：security@cn.gree.com</p>
      <p class="p_text" style="font-weight: bold">电话：0756-8579928</p>
      <p class="p_text">注册地址：珠海横琴新区汇通三路108号办公608</p>
      <p class="p_text">我们设立了个人信息保护专职部门，一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过上述途径寻求解决方案。</p>
    </div>
  </div>
</template>

<script>
import guide from '@/components/guide'

export default {
  name: 'privacyPolocy',
  components: {
    // guide,
    // wordBox,
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped></style>

<style lang="less" scoped>
// 主标题
.p_title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: rgb(28, 54, 99);
}

// 副标题
.p_title2 {
  font-size: 16px;
  font-weight: bold;
  text-indent: 1.4rem;
  margin-top: 0.5rem;
  text-align: left;
  line-height: 1.5rem;
  color: rgb(28, 54, 99);
}

// 正文
.p_text {
  font-size: 14px;
  /*font-weight: bold;*/
  /*margin-bottom: 0.5rem;*/
  text-indent: 1.4rem;
  text-align: left;
  line-height: 1.5rem;
  color: rgb(28, 54, 99);
}

.p_table {
  font-size: 14px;
  border: 1px solid #ddd;
  text-align: left;
  color: rgb(28, 54, 99);
}

.p_tableborder {
  font-size: 12px;
  border: 1px solid #ddd;
  text-align: left;
  line-height: 1.5rem;

  a {
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}

@media only screen and (min-width: 320px) {
  .x-top {
    /*background: url("../../../assets/img/mobile/product/product3/background.png") !important;*/
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center center !important;
    box-sizing: border-box;
  }
}

@media only screen and (min-width: 768px) {
  .x-top {
    /*background: url("../../../assets/img/pc/product/product3/background.png") !important;*/
    background-repeat: no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
    box-sizing: border-box;
  }
}
</style>
